export default __webpack_public_path__ + "static/media/8.658bddac.mp3";